import { CurtainOperationType } from "./curtain-operation-type";

export class CurtainOperation {
	type: CurtainOperationType;
	direction: string;
	target: string;
}